import type { Component } from '../router';
import { HealthPill } from './HealthPill';
import { LocaleSwitcher } from './LocaleSwitcher';
import { TopNav, TabBar } from './nav/AppNav';

// isActiveTab moved to the nav model in ; re-exported here so existing
// importers (icons.test) keep their path.
export { isActiveTab } from './nav/navModel';

// AppShell — the app-shell layout primitive: the three regions every
// signed-in screen shares — top navigation, a centred content column, and the
// phone bottom navigation. Theme-aware (everything inherits the root data-theme
// tokens) and auth-aware (the navs filter to what this role + device class can
// reach, ). The shell mounts both navs; nav.css shows the right one for
// the viewport, so there is no device branch here.
export class AppShell implements Component {
  private root: HTMLElement | null = null;
  private readonly topNav = new TopNav();
  private readonly tabBar = new TabBar();
  private phonePill: HealthPill | null = null;
  private phoneLocale: LocaleSwitcher | null = null;

  constructor(private inner: Component) {}

  mount(host: HTMLElement): void {
    const shell = document.createElement('div');
    shell.className = 'shell';

    this.topNav.mount(shell);

    const main = document.createElement('main');
    main.className = 'shell__main';
    shell.appendChild(main);

    this.tabBar.mount(shell);

    // Phone-only floating chips (the top nav, which carries the desktop pill +
    // locale switcher, is hidden below 768px). Health sits top-right, locale
    // top-left, so they never collide.
    const phoneHealth = document.createElement('div');
    phoneHealth.className = 'healthpill-phone';
    shell.appendChild(phoneHealth);
    this.phonePill = new HealthPill();
    this.phonePill.mount(phoneHealth);

    const phoneLocale = document.createElement('div');
    phoneLocale.className = 'locale-switcher-phone';
    shell.appendChild(phoneLocale);
    this.phoneLocale = new LocaleSwitcher();
    this.phoneLocale.mount(phoneLocale);

    host.appendChild(shell);
    this.root = shell;
    this.inner.mount(main);
  }

  unmount(): void {
    this.phoneLocale?.unmount();
    this.phoneLocale = null;
    this.phonePill?.unmount();
    this.phonePill = null;
    this.tabBar.unmount();
    this.topNav.unmount();
    if (this.inner.unmount) this.inner.unmount();
    this.root?.remove();
    this.root = null;
  }
}
